import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRunkeeperComponent } from './simple-icons-runkeeper.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRunkeeperComponent ],
    exports:      [ SimpleIconsRunkeeperComponent ],
    bootstrap:    []
})
export class SimpleIconsRunkeeperModule {}
